import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { TrustedBy } from '../components/TrustedBy';
import { ProblemSection } from '../components/ProblemSection';
import { CapabilitiesSection } from '../components/CapabilitiesSection';
import { AITransformationSection } from '../components/AITransformationSection';
import { PlatformArchitecture } from '../components/PlatformArchitecture';
import { TrustScoreSection } from '../components/TrustScoreSection';
import { SecuritySection } from '../components/SecuritySection';
import { AboutSection } from '../components/AboutSection';
import { CTASection } from '../components/CTASection';
export function Home() {
  return <>
      <HeroSection data-id="element-811" data-mp="2dhgtn8kai6cq" />
      <TrustedBy data-id="element-812" data-mp="2dhytef65v2pe" />
      <ProblemSection data-id="element-813" data-mp="2dii69hgyf0wk" />
      <CapabilitiesSection data-id="element-814" data-mp="2dfm3nfu5vo1s" />
      <AITransformationSection data-id="element-815" data-mp="3kvk5aj0nqz5g" />
      <PlatformArchitecture data-id="element-816" data-mp="3ku8tbvx26l39" />
      <TrustScoreSection data-id="element-817" data-mp="3kv0k8tfpnun7" />
      <SecuritySection data-id="element-818" data-mp="3owvmc05guc21" />
      <AboutSection data-id="element-819" data-mp="3ow43lpwyw8t6" />
      <CTASection data-id="element-820" data-mp="3ovkik0c0t4ax" />
    </>;
}